import PropTypes from "prop-types";
import React, { useCallback } from "react";
import FormElement from "../components/FormBuilder/FormElement";
import { Grid, Paper, Box } from "@mui/material";
import { FormProvider } from "../FormContext";
import { USERROLE } from "../utils/commonConstant";
const FormPreview = ({
  elements,
  trackChangeDisplayBy = USERROLE.ADMIN,
  isShowTrackHistory = false,
  isEditable = false,
  setElements,
  isPresentMode = false,
}) => {
  const updateElementProps = useCallback(
    (id, newProps) => {
      const updateProps = (elements) => {
        return elements
          .map((element) => {
            if (element.id === id) {
              if (newProps.remove === true) {
                return null; // Mark element for removal
              }
              return { ...element, props: { ...element.props, ...newProps } };
            }
            if (element.items) {
              const updatedItems = updateProps(element.items).filter(
                (item) => item !== null
              );
              return { ...element, items: updatedItems };
            }
            return element;
          })
          .filter((element) => element !== null); // Remove marked elements
      };
      setElements((prevElements) => updateProps(prevElements));
    },
    [setElements]
  );

  return (
    <FormProvider>
      <Grid
        container
        justifyContent="center"
        sx={{ backgroundColor: "#CCCCCC" }}
      >
        <Grid item xs={12} md={8}>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Paper elevation={3} sx={{ padding: 2, minHeight: "700px" }}>
                  <Grid container spacing={2}>
                    {elements.map((element, index) => (
                      <Grid
                        xs={12}
                        item
                        key={element.id}
                        sx={{
                          ...(element.type === "logo" && {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }),
                        }}
                      >
                        <FormElement
                          element={element}
                          dragHandle={false}
                          formPreview={true}
                          trackChangeDisplayBy={trackChangeDisplayBy}
                          isShowTrackHistory={isShowTrackHistory}
                          onPropsChange={(newProps, forceSave = true) => {
                            if (isEditable) {
                              updateElementProps(element.id, newProps);
                            }
                          }}
                          isPresentMode={isPresentMode}
                        />
                      </Grid>
                    ))}
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </FormProvider>
  );
};

FormPreview.propTypes = {
  elements: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default FormPreview;